import React from 'react';
import Lines from './Lines';

const Thead = ({ head = [] }) => {
    return (
        <thead>
            <tr>
                {
                    head.map((item, i) => (
                        <th key={ i }>{ item }</th>
                    ))
                }
            </tr>
        </thead>
    );
};
const Td = ({ td }) => {
    return (
        <td>
            {
                Array.isArray(td) ? (
                    <Lines lines={ td } />
                ): td
            }
        </td>
    );
};

const Row = ({ rows, id }) => {
    return (
        <tbody>
            {
                rows.map((row, r) => (
                    <tr key={ r }>
                        {
                            row.map((td, t) => (
                                <Td td={ td } key={ `${ id }${ t }${ r }` } />
                            ))
                        }
                    </tr>
                ))
            }
        </tbody>
    );
};

const TermsTable = ({ table = {}, id }) => {
    const { head, body, style = ''} = table;
    const tableStyle = `table ${ style }`
    return (
        <>
            {
                body ? (
                    <table className={ tableStyle }>
                        {
                            head ? (
                                <Thead head={ head } />
                            ) : null
                        }
                        <Row rows={ body } id={ id } />
                    </table>
                ): null
            }
        </>
    );
};

export default TermsTable;
